{
  "fr": {
    "issue": {
      "actions": {
        "approve_for_customer": "Auto-approuver pour le client",
        "assign": "Assigner",
        "collapse": "Réduire les points",
        "create_category": "Ajouter une nouvelle catégorie",
        "create_issue": "Créer un point",
        "create_issue_customer": "Signaler le défaut",
        "delete": "Supprimer le point",
        "expand": "Développer les points",
        "export_images": "Télécharger des images",
        "hideActivity": "Cacher l'activité",
        "openConversation": "Ouvrir la conversation",
        "reject_for_customer": "Rejet pour le client",
        "show": "Montrer point",
        "showActivity": "Montrer l'activité",
        "startConversation": "Démarrer une conversation",
        "start_conversation": "Démarrer une conversation sur ce point",
        "undo_customer_approval": "Annuler l'approbation du client",
        "undo_customer_rejection": "Annuler le rejet du client",
        "update": "Points de mise à jour"
      },
      "attributes": {
        "approval_status": "Approbation du client",
        "assignee": "Désignée",
        "category": "Categorie",
        "created_at": "Créé",
        "deadline": "Date limite",
        "description": "Description",
        "issue_list_type": "Liste de points",
        "name": "Nom",
        "responsible": "Responsable",
        "status": "Statut",
        "statuses": {
          "approval_not_requested": "Non demandé",
          "approval_requested": "Demandée",
          "approved": "Approuvé",
          "completed": "Complété",
          "created": "Ouvert",
          "declined": "Rejeté",
          "inbox": "Envoyé",
          "not_completed": "Non Complété",
          "ongoing": "En cours"
        },
        "updated_at": "Dernière mise à jour"
      },
      "edit_actions": {
        "edit_category": "Catégorie",
        "edit_deadline": "Date limite",
        "edit_issue_list_type": "Liste de points",
        "edit_responsible": "Responsable",
        "edit_status": "Statut"
      },
      "labels": {
        "activity": "Activité",
        "addImagesSubtitle": "Une image vaut mieux qu'un long discours",
        "addImagesTitle": "Ajouter des images pour nous aider à mieux comprendre le défaut",
        "after_care_page_title": "Vos points",
        "all_categories_can_be_managed_under": "Toutes les catégories peuvent être gérées sous les",
        "approvalNotRequested": "Approbation non demandée",
        "approvalRequested": "Approbation demandée",
        "approved": "Approuvé",
        "approvedInfo": "Le client a approuvé ce point",
        "assignee": "Responsable",
        "cancelCustomerApproval": "Annuler la demande d'approbation du client",
        "collapse": "Cacher l'activité",
        "company_settings": "paramètres de l'organisation",
        "count_edit": "Modifier le point | Modifier {count} points",
        "create_new_category?": "Vous ne trouvez pas la catégorie dont vous avez besoin ? Créez-en une nouvelle !",
        "created_at": "Créé à",
        "customerApproved": "Approuvé par le client",
        "customerRejected": "Rejeté par le client",
        "deadline_date": "Date limite",
        "description": "Description",
        "descriptionSubtitle": "Utiliser des puces et des phrases courtes pour faciliter la compréhension du défaut",
        "descriptionTitle": "Entrer une courte description",
        "edit_category": "Modifier la catégorie",
        "edit_issue": "Modifier le point",
        "isThisPointFixed": "Est-ce résolu selon vous ?",
        "issue_category_name": "Catégorie",
        "issue_status_name": "Statut",
        "issues_clear_selection": "Effacer la sélection",
        "issues_select_all_pages": "Sélectionner les {total} points",
        "issues_select_one": "Sélectionner au moins 1 point",
        "issues_selected": "points sélectionnés",
        "issues_selected_all_pages": "Les {total} points sont sélectionnés",
        "issues_selected_count": "{selected} point sélectionné | {selected} points sélectionnés",
        "name": "Nom",
        "new": "Créer un nouveau point",
        "new_category": "Nouvelle catégorie",
        "noDescriptionYet": "Pas encore de description",
        "no_issue_deadline": "Aucune date limite définie",
        "no_issues": "Aucun point",
        "no_responsible": "Aucun responsable assigné",
        "origin": "Origine",
        "reason": "Raison",
        "redoRequest": "Demande de redémarrage",
        "requestCustomerApproval": "Demander l'approbation du client",
        "requested": "Demandé",
        "requestedInfo": "Approbation du client demandée",
        "resetRequest": "Demande de réinitialisation",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Responsable",
        "return_to_overview": "Retour",
        "showIssuesfor": "Montrer les points pour",
        "statusExplained": "Que signifie chaque couleur de statut",
        "subjectSubtitle": "Seulement 1 notification par défaut est requise. Nous nous occupons du reste",
        "subjectTitle": "Décrire le défaut en quelques mots",
        "unit_issues_will_be_shown_here": "Toutes les unités attachées à la liste des points seront affichées ici",
        "unit_name": "Nom de l'unité",
        "updated_at": "Dernière mise à jour",
        "waitingForApproval": "Ce point doit d'abord être accepté par {client_name} avant de pouvoir entamer une conversation",
        "whyIsThisPointNotFixed": "Pourquoi ce point n'est-il pas résolu?",
        "youApprovedThisPoint": "Résolu selon vous",
        "youRejectedThisPoint": "Non résolu selon vous"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Au moment où un employé crée des défauts pour cette unité, ils apparaîtront ici.",
            "title": "Aucun défaut créé pour cette unité pour le moment"
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "Lorsque les clients créent de nouvelles remarques, elles s'affichent à nouveau ici.",
            "title": "Vous avez traité toutes les remarques entrantes des clients"
          },
          "none": {
            "subtitle": "Commencer à enregistrer ce qui devrait être corrigé ou amélioré",
            "title": "Créer un point"
          },
          "overview": {
            "subtitle": "Créez votre premier numéro dans une unité pour commencer",
            "title": "Les points créés dans toutes vos unités seront affichés ici"
          },
          "unit": {
            "title": "Tous les points pour cette unité seront affichés ici"
          }
        },
        "partners": {
          "none": {
            "subtitle": "A partir du moment où vous êtes affecté à des points, ils seront visibles ici.",
            "title": "Aucun point ne vous a encore été attribué."
          }
        }
      },
      "sortGroups": {
        "date": "Date",
        "deadline": "Date limite",
        "name": "Nom"
      },
      "toasts": {
        "update": "Le point a été mis à jour"
      },
      "validation": {
        "issue_list_type_required": "La liste de points est requise",
        "pleaseProvideAReason": "Veuillez fournir une raison",
        "status_required": "Le statut est requis"
      }
    }
  }
}
